(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
    This controls the modal for when youtube or rumble videos end
 */

//launch modal when youtube video is stopped
function v1(gstate, event, playerID) {
  if (event.data == YT.PlayerState.ENDED) {
    if (window.screen.width > 490) {
      launchModal(playerID);
    }
  }
}
function stopv() {
  player.stopVideo();
  if (window.screen.width > 490) {
    launchModal();
  }
}

/* Popup code for after the video */
(function (b) {
  b.fn.bPopup = function (z, F) {
    function K() {
      a.contentContainer = b(a.contentContainer || c);
      switch (a.content) {
        case "iframe":
          var h = b('<iframe class="b-iframe" ' + a.iframeAttr + "></iframe>");
          h.appendTo(a.contentContainer);
          r = c.outerHeight(!0);
          s = c.outerWidth(!0);
          A();
          h.attr("src", a.loadUrl);
          k(a.loadCallback);
          break;
        case "image":
          A();
          b("<img />").load(function () {
            k(a.loadCallback);
            G(b(this));
          }).attr("src", a.loadUrl).hide().appendTo(a.contentContainer);
          break;
        default:
          A(), b('<div class="b-ajax-wrapper"></div>').load(a.loadUrl, a.loadData, function () {
            k(a.loadCallback);
            G(b(this));
          }).hide().appendTo(a.contentContainer);
      }
    }
    function A() {
      a.modal && b('<div class="b-modal ' + e + '"></div>').css({
        backgroundColor: a.modalColor,
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        opacity: 0,
        zIndex: a.zIndex + t
      }).appendTo(a.appendTo).fadeTo(a.speed, a.opacity);
      D();
      c.data("bPopup", a).data("id", e).css({
        left: "slideIn" == a.transition || "slideBack" == a.transition ? "slideBack" == a.transition ? g.scrollLeft() + u : -1 * (v + s) : l(!(!a.follow[0] && m || f)),
        position: a.positionStyle || "absolute",
        top: "slideDown" == a.transition || "slideUp" == a.transition ? "slideUp" == a.transition ? g.scrollTop() + w : x + -1 * r : n(!(!a.follow[1] && p || f)),
        "z-index": a.zIndex + t + 1
      }).each(function () {
        a.appending && b(this).appendTo(a.appendTo);
      });
      H(!0);
    }
    function q() {
      a.modal && b(".b-modal." + c.data("id")).fadeTo(a.speed, 0, function () {
        b(this).remove();
      });
      a.scrollBar || b("html").css("overflow", "auto");
      b(".b-modal." + e).unbind("click");
      g.unbind("keydown." + e);
      d.unbind("." + e).data("bPopup", 0 < d.data("bPopup") - 1 ? d.data("bPopup") - 1 : null);
      c.undelegate(".bClose, ." + a.closeClass, "click." + e, q).data("bPopup", null);
      H();
      return !1;
    }
    function G(h) {
      var b = h.width(),
        e = h.height(),
        d = {};
      a.contentContainer.css({
        height: e,
        width: b
      });
      e >= c.height() && (d.height = c.height());
      b >= c.width() && (d.width = c.width());
      r = c.outerHeight(!0);
      s = c.outerWidth(!0);
      D();
      a.contentContainer.css({
        height: "auto",
        width: "auto"
      });
      d.left = l(!(!a.follow[0] && m || f));
      d.top = n(!(!a.follow[1] && p || f));
      c.animate(d, 250, function () {
        h.show();
        B = E();
      });
    }
    function L() {
      d.data("bPopup", t);
      c.delegate(".bClose, ." + a.closeClass, "click." + e, q);
      a.modalClose && b(".b-modal." + e).css("cursor", "pointer").bind("click", q);
      M || !a.follow[0] && !a.follow[1] || d.bind("scroll." + e, function () {
        B && c.dequeue().animate({
          left: a.follow[0] ? l(!f) : "auto",
          top: a.follow[1] ? n(!f) : "auto"
        }, a.followSpeed, a.followEasing);
      }).bind("resize." + e, function () {
        w = y.innerHeight || d.height();
        u = y.innerWidth || d.width();
        if (B = E()) clearTimeout(I), I = setTimeout(function () {
          D();
          c.dequeue().each(function () {
            f ? b(this).css({
              left: v,
              top: x
            }) : b(this).animate({
              left: a.follow[0] ? l(!0) : "auto",
              top: a.follow[1] ? n(!0) : "auto"
            }, a.followSpeed, a.followEasing);
          });
        }, 50);
      });
      a.escClose && g.bind("keydown." + e, function (a) {
        27 == a.which && q();
      });
    }
    function H(b) {
      function d(e) {
        c.css({
          display: "block",
          opacity: 1
        }).animate(e, a.speed, a.easing, function () {
          J(b);
        });
      }
      switch (b ? a.transition : a.transitionClose || a.transition) {
        case "slideIn":
          d({
            left: b ? l(!(!a.follow[0] && m || f)) : g.scrollLeft() - (s || c.outerWidth(!0)) - C
          });
          break;
        case "slideBack":
          d({
            left: b ? l(!(!a.follow[0] && m || f)) : g.scrollLeft() + u + C
          });
          break;
        case "slideDown":
          d({
            top: b ? n(!(!a.follow[1] && p || f)) : g.scrollTop() - (r || c.outerHeight(!0)) - C
          });
          break;
        case "slideUp":
          d({
            top: b ? n(!(!a.follow[1] && p || f)) : g.scrollTop() + w + C
          });
          break;
        default:
          c.stop().fadeTo(a.speed, b ? 1 : 0, function () {
            J(b);
          });
      }
    }
    function J(b) {
      b ? (L(), k(F), a.autoClose && setTimeout(q, a.autoClose)) : (c.hide(), k(a.onClose), a.loadUrl && (a.contentContainer.empty(), c.css({
        height: "auto",
        width: "auto"
      })));
    }
    function l(a) {
      return a ? v + g.scrollLeft() : v;
    }
    function n(a) {
      return a ? x + g.scrollTop() : x;
    }
    function k(a) {
      b.isFunction(a) && a.call(c);
    }
    function D() {
      x = p ? a.position[1] : Math.max(0, (w - c.outerHeight(!0)) / 2 - a.amsl);
      v = m ? a.position[0] : (u - c.outerWidth(!0)) / 2;
      B = E();
    }
    function E() {
      return w > c.outerHeight(!0) && u > c.outerWidth(!0);
    }
    b.isFunction(z) && (F = z, z = null);
    var a = b.extend({}, b.fn.bPopup.defaults, z);
    a.scrollBar || b("html").css("overflow", "hidden");
    var c = this,
      g = b(document),
      y = window,
      d = b(y),
      w = y.innerHeight || d.height(),
      u = y.innerWidth || d.width(),
      M = /OS 6(_\d)+/i.test(navigator.userAgent),
      C = 200,
      t = 0,
      e,
      B,
      p,
      m,
      f,
      x,
      v,
      r,
      s,
      I;
    c.close = function () {
      a = this.data("bPopup");
      e = "__b-popup" + d.data("bPopup") + "__";
      q();
    };
    return c.each(function () {
      b(this).data("bPopup") || (k(a.onOpen), t = (d.data("bPopup") || 0) + 1, e = "__b-popup" + t + "__", p = "auto" !== a.position[1], m = "auto" !== a.position[0], f = "fixed" === a.positionStyle, r = c.outerHeight(!0), s = c.outerWidth(!0), a.loadUrl ? K() : A());
    });
  };
  b.fn.bPopup.defaults = {
    amsl: 50,
    appending: !0,
    appendTo: "body",
    autoClose: !1,
    closeClass: "b-close",
    content: "ajax",
    contentContainer: !1,
    easing: "swing",
    escClose: !0,
    follow: [!0, !0],
    followEasing: "swing",
    followSpeed: 500,
    iframeAttr: 'scrolling="no" frameborder="0"',
    loadCallback: !1,
    loadData: !1,
    loadUrl: !1,
    modal: !0,
    modalClose: !0,
    modalColor: "#000",
    onClose: !1,
    onOpen: !1,
    opacity: 0.7,
    position: ["auto", "auto"],
    positionStyle: "absolute",
    scrollBar: !0,
    speed: 250,
    transition: "fadeIn",
    transitionClose: !1,
    zIndex: 9999
  };
})(jQuery);

// Semicolon (;) to ensure closing of earlier scripting
// Encapsulation
// $ is assigned to jQuery
// ;(function($) {
//
//     // DOM Ready
//     $(function() {
//
//         // Binding a click event
//         // From jQuery v.1.7.0 use .on() instead of .bind()
//         $('#my-button').bind('click', function(e) {
//
//             // Prevents the default action to be triggered.
//             e.preventDefault();
//
//             // Triggering bPopup when click event is fired
//             $('[id^="element_to_pop_up"]').bPopup();
//
//         });
//
//     });
//
// })(jQuery);

/*
    Launches the modal for videos
 */
function launchModal(playerID) {
  // Semicolon (;) to ensure closing of earlier scripting
  // Encapsulation
  // $ is assigned to jQuery
  ;
  (function ($) {
    // DOM Ready
    $(function () {
      var postID = $("#" + playerID).closest('[data-single-post-id]').attr('data-single-post-id');
      $('[id="element_to_pop_up-' + postID + '"]').bPopup({
        /*modal:false*/
      });
    });
  })(jQuery);
}
(function (jQuery) {
  var nav = jQuery('#top-navigation');
  var nav_container = jQuery('#logo-top-navigation');
  var side_nav = jQuery('#mts-sidenav');
  var logo = nav_container.find('img');
  var offLogoSrc = logo.attr('data-src-pin-off');
  var onLogoSrc = logo.attr('data-src-pin-on');
  var theH = jQuery(window).height() - (50 + 40 - 14 + 30);
  side_nav.css('min-height', theH);

  //Pin Header Post Info for Single post only, to show Post title and Share buttons when Scroll down.
  if (jQuery('body').hasClass('single-post')) {
    var navHeight = 0;
    var content = 0;
    var diff = 0;
    navHeight = jQuery('.top-navigation').height();
    content = jQuery('.post-single-content').offset().top;
    diff = content - navHeight;
    jQuery(window).scroll(function () {
      var scrollTop = jQuery(window).scrollTop();
      if (scrollTop > (diff < navHeight ? content : diff)) {
        if (!nav.hasClass('pin-on')) {
          logo.hide();
          nav.addClass('pin-on').removeClass('pin-off');
          var img = new Image();
          img.onload = function () {
            logo.attr('src', img.src);
            logo.show();
          };
          img.src = onLogoSrc;
        }
      } else {
        if (nav.hasClass('pin-on')) {
          logo.hide();
          nav.removeClass('pin-on').addClass('pin-off');
          logo.attr('src', offLogoSrc);
          logo.show();
        }
      }
    });
  }

  //Close the menu overlay when click outside of the menu box
  jQuery('body').on('click', function (e) {
    var _this = e.target;
    if (jQuery(_this).closest('#mts-sidenav').length) return;
    if (_this.id === 'mobile_menu' || _this.id === 'mts-sidenav') return;
    var _root = jQuery('html');
    if (_root.hasClass('nav-open')) {
      if (typeof closeNav !== 'undefined' && jQuery.isFunction(closeNav)) closeNav();
    }
  });

  //Infinite Scroll post
  if (typeof infinite_script_obj !== 'undefined') {
    //Ajax loading spinner
    var jQueryloading = jQuery('#ajax-loading');
    var endOfScroll = null;

    //Keep track of post IDs, to avoid duplicate loading
    var loaderPostIDs = [];
    if (loaderPostIDs.length === 0) {
      loaderPostIDs = JSON.parse(atob(jQuery('[data-id="current_post_id"]').last().val()));
    }

    //Hardcoding popular Categories
    var targeted_categories = infinite_script_obj.targeted_categories;
    var loaderCategoryIDs = [];
    if (loaderCategoryIDs.length === 0) {
      loaderCategoryIDs = JSON.parse(atob(jQuery('[data-id="current_category_id"]').last().val()));
    }

    //Once run out of older posts, start from this ID, top post of the Adjacent posts
    var resetPostID = jQuery('[data-id="reset_post_id"]').first().val();

    //Keep track of max number of posts loading
    var numOfMaxPosts = 20; //We can change this number
    var numOfPostLoaded = 1; //Initiate with 1st Article, so set the var to 1

    var infiniteObj = {
      //Main function to load next Post after each post in the viewport
      loadAnArticle: function loadAnArticle(dataToSend) {
        jQueryloading.show().addClass('progressing');
        jQuery.post(infinite_script_obj.url + dataToSend.action + infinite_script_obj.gdpr, dataToSend, function (response) {
          loaderPostIDs.push(dataToSend.metaspoonNextPostId);
          numOfPostLoaded++;
          if (response !== null && response.isSuccess && response.data !== '') {
            jQuery(".metaspoon-infinite-loaded").first().replaceWith(response.data);
          }
        }).always(function () {
          jQueryloading.hide().removeClass('progressing');
        });
      },
      /*loadAds: function(dataToSend, loaderDiv){
            jQuery.post(infinite_script_obj.url + dataToSend.action + infinite_script_obj.gdpr, dataToSend, function(response) {
                if(response !== null && response.isSuccess && response.data !== ''){
                  jQuery("#" + loaderDiv).replaceWith(response.data);
              }
            });
        },*/

      /*getPermalink: function(dataToSend){
            jQueryloading.show().addClass('progressing');
          jQuery.post(infinite_script_obj.url + dataToSend.action + infinite_script_obj.gdpr, dataToSend, function(response) {
                //We don't need it, as we are loading same prev loaded article
              //loaderPostIDs.push(dataToSend.metaspoonNextPostId);
              if(response !== null && response.isSuccess && response.data !== ''){
                    //Encrypt Categories Array
                  var jQuerycategories_json = btoa(JSON.stringify(loaderCategoryIDs));
                  jQuery('[id="loaded_category"]').val(jQuerycategories_json);
                  //Encrypt Posts Array
                  var jQueryposts_json = btoa(JSON.stringify(loaderPostIDs));
                  jQuery('[id="loaded_post"]').val(jQueryposts_json);
                    jQuery('#metaspoon-infinite-form').attr('action', response.data).submit();
                }
            }).always(function(){
              jQueryloading.hide().removeClass('progressing');
          });
        },*/

      //Display Related post Thumb at the bottom of page Scroll
      loadRelatedArticles: function loadRelatedArticles(dataToSend) {
        jQueryloading.show().addClass('progressing');
        jQuery.ajax({
          url: infinite_script_obj.url + dataToSend.action + infinite_script_obj.gdpr,
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(dataToSend),
          success: function success(response) {
            if (response !== null && response.isSuccess && response.data !== '') {
              jQuery("#metaspoon-infinite-related-loaded").replaceWith(response.data);
            }
          }
        }).always(function () {
          jQueryloading.hide().removeClass('progressing');
          endOfScroll = true;
        });
      },
      //Function to load a latest post from next Popular list of
      //Categories when rendering all posts from a certain category if done.
      loadCategoryPost: function loadCategoryPost(dataToSend) {
        jQueryloading.show().addClass('progressing');
        jQuery.post(infinite_script_obj.url + dataToSend.action + infinite_script_obj.gdpr, dataToSend, function (response) {
          loaderCategoryIDs.push(dataToSend.metaspoonNextCategory);
          if (response !== null && response.isSuccess && response.data !== '' && response.data.metaspoonFirstPostContent !== null && response.data.metaspoonFirstPostContent !== '') {
            loaderPostIDs.push(response.data.metaspoonFirstPostID);
            numOfPostLoaded++;
            jQuery(".metaspoon-infinite-loaded").first().replaceWith(response.data.metaspoonFirstPostContent);
          }
        }).always(function () {
          jQueryloading.hide().removeClass('progressing');
        });
      }
    };

    /****Load Adjacent article when scroll to bottom of the page: START ****/
    jQuery(window).scroll(function () {
      var footerPos = Math.round(jQuery(document).height());
      var pos = Math.round(jQuery(window).scrollTop());
      var height = Math.round(jQuery(window).height());
      var halfway = (pos / footerPos * 100).toFixed(0);

      //if(pos + height === footerPos)
      //if( ( footerPos - (height + pos) ) / footerPos === 0 ) //Best smooth

      // Load next article
      if (pos + height >= footerPos - 100) {
        var currentArticel = jQuery('.metaspoon-post-header').last();
        var currentPostId = currentArticel.attr('data-current-post');
        var nextPostId = currentArticel.attr('data-next-post');
        var currentPostType = currentArticel.attr('data-current-target-post');
        var targetPostType = currentArticel.attr('data-target-post');
        var dataToSend = {};
        if (!jQueryloading.hasClass('progressing') && (loaderPostIDs.length === 0 || jQuery.inArray(nextPostId, loaderPostIDs) === -1)) {
          //If reached page Limit, then redirect to nextPost but load the prev post again at first place
          if (numOfPostLoaded >= numOfMaxPosts && typeof nextPostId !== 'undefined' && nextPostId !== null && nextPostId !== '') {
            /*dataToSend = {
                'action': 'single_permalink',
                'metaspoonNextPostId': currentPostId,
                'metaspoonPostType': currentPostType,
                'metaspoonResetPost': typeof resetPostID !== 'undefined' && resetPostID !== "" && resetPostID !== null ? resetPostID : null,
                'metaspoonQueryStr': window.location.href.split('?')[1]
            };
              infiniteObj.getPermalink(dataToSend);*/

            if (!endOfScroll) {
              var _thisURL = currentArticel.attr('data-curr-url');
              dataToSend = {
                'action': 'related_articles',
                'metaspoonPostId': currentPostId,
                'metaspoonExemptPosts': loaderPostIDs,
                'metaspoonAvailableCategories': targeted_categories.length > 0 ? jQuery.grep(targeted_categories, function (val, index) {
                  return jQuery.inArray(val, loaderCategoryIDs) === -1;
                }) : [],
                'metaspoonQueryStr': _thisURL.split('?')[1]
              };
              infiniteObj.loadRelatedArticles(dataToSend);
            }
          } else {
            if (typeof nextPostId !== 'undefined' && nextPostId !== null && nextPostId !== '') {
              dataToSend = {
                'action': 'scroll',
                'metaspoonNextPostId': nextPostId,
                'metaspoonPostType': targetPostType,
                'metaspoonResetPost': typeof resetPostID !== 'undefined' && resetPostID !== "" && resetPostID !== null ? resetPostID : null,
                'metaspoonQueryStr': window.location.href.split('?')[1]
              };
              infiniteObj.loadAnArticle(dataToSend);
            } else {
              // SO we reached the end of all posts under a category

              //(1) Render Popular Categories
              var selectedCategory = null;
              for (var i = 0; i < targeted_categories.length; i++) {
                if (jQuery.inArray(targeted_categories[i], loaderCategoryIDs) === -1) {
                  selectedCategory = targeted_categories[i];
                  dataToSend = {
                    'action': 'category_post',
                    'metaspoonNextCategory': selectedCategory,
                    'metaspoonPostType': 'older',
                    'metaspoonQueryStr': window.location.href.split('?')[1]
                  };
                  infiniteObj.loadCategoryPost(dataToSend);
                  break;
                }
              }
            }
          }
        }
      }
    });
    /****Load Adjacent article when scroll to bottom of the page: END ****/

    /****Load Ads template for Mobile ONLY: START****/
    /*var infScreenW = window.innerWidth > screen.width ? screen.width  : window.innerWidth;
    var infDevice = 'd';
    if (infScreenW <= 480 && infScreenW >= 0 ){
        infDevice = 'm'; //sets platform as mobile
    } else if (infScreenW <= 960 && infScreenW > 599){
        infDevice = 't'; //sets platform as tablet
    } else {
        infDevice = 'd'; //sets platform as desktop
    }
      if(typeof infDevice !== 'undefined' && infDevice === 'm') {
        jQuery(window).scroll(function () {
              var footerPos = jQuery(document).height();
            var pos = jQuery(window).scrollTop();
            var height = jQuery(window).height();
            var navHeight = jQuery('.top-navigation').outerHeight();
            // var navPos = jQuery('.top-navigation').offset().top;
                var headTitle = jQuery('header[id^="post-header-"]');
            headTitle.each(function (index) {
                  var hTop = jQuery(this).offset().top,
                    hHeight = jQuery(this).outerHeight();
                  // if(hTop >= height*.3 && (hHeight + hTop <= height*.6) && !jQuery(this).hasClass('on-viewport')){
                //     jQuery(this).addClass('on-viewport');
                // }
                  if (pos + navHeight >= hTop && !jQuery(this).hasClass('on-viewport')) {
                    jQuery(this).addClass('on-viewport');
                      var _thisPostID = jQuery(this).attr('data-header-post-id');
                    var _thisURL = jQuery(this).closest('.single_post.loaded').attr('data-curr-url');
                      var dataToSend = {
                        'action': 'metaspoon_infinite_ads',
                        'metaspoonPostId': _thisPostID,
                        'metaspoonQueryStr': _thisURL.split('?')[1]
                    };
                      infiniteObj.loadAds(dataToSend, 'metaspoon-infinite-ad-load-' + _thisPostID);
                }
              });
          });
    }*/
    /****Load Ads template for Mobile ONLY: END****/

    /****Decide when scroll into an article viewport: START****/
    jQuery(window).scroll(function () {
      jQuery('h1.entry-title').each(function (index) {
        var hTop = jQuery(this).offset().top,
          hHeight = jQuery(this).outerHeight(),
          navHeight = jQuery('.top-navigation').outerHeight(),
          wScroll = jQuery(window).scrollTop();
        if (hTop <= wScroll && hTop + hHeight + navHeight > wScroll) {
          var _parent = jQuery(this).closest('.single_post');
          var _url = _parent.attr('data-curr-url');
          if (location.href !== _url) {
            //(1) Update Header Title
            jQuery('.toggle-header h4').text(jQuery(this).text());

            //(2) Update browser URL
            history.pushState({}, jQuery(this).text(), _url);

            //(3) Update Browser Title
            document.title = jQuery(this).text();

            //(4) Update Facebook Share and Next Article link
            var _socialNav = _parent.find('[id^="social-nav-"]').html();
            jQuery('.toggle-header #social-nav').html(_socialNav);

            //(5) Send Google Analytics event
            ga('send', 'event', 'infinite-scroll', 'Article in viewport', _url);
            ga('global.send', 'event', 'infinite-scroll', 'Article in viewport', _url);
          }
        }
      });
    });
    /****Decide when scroll into an article viewport: END****/
  }
})(jQuery);
/*
    Here we have js files that we are unsure what they do
 */

// console.log('running uknonw OFF');
/*
    No clue what this does - maybe used for infinite scroll?
 */
// (function ($) {
//     var sidebar = $('#sidebars .sidebar');
//     $(document).ready(function () {
//         $(window).scroll(function () {
//             if ($(window).height() <= 700 && $('body').height() <= ($(window).height() + $(window).scrollTop())) {
//                 sidebar.css('bottom', '0');
//             }else{
//                 sidebar.css('bottom', 'inherit');
//             }
//         });
//     });
//
// })(jQuery);
/*
    Contains all js for the login modal
 */

domReady(function () {
  /*
      Check if user is logged in but the login top navigation, etc is not loaded.
        This would happen if the user logged in using no-reload and then clicked back. Due
      to caching, it would appear to the user as though they are not logged into wordpress
      when in fact they are.
        So we will read the js variable from the ajax call to see if the use is in face logged in
      and we will then load the top navigation and other functions for when the user is logged in.
   */
  //first check if user is already logged in visually ('logged-in' will be a class in body tag),
  //if 'logged-in' is already set in body tag, system should have already loaded navigation
  if (document.body.classList.contains('logged-in') === false) {
    window.getApiData().then(function (response) {
      if (response.data.logged_in === 1) {
        window.mts_logged_in = 1;
        if (window.mts_logged_in === 1) window.login_without_reload();
      }
    });
  }

  //create all the link variables for the differnt sections
  var forgot_password_link = document.getElementById('login-modal-forgot-pass'),
    register_account_link = document.getElementById('login-modal-register-account'),
    back_to_login_text = document.getElementsByClassName('login-modal-back-to-login-text');

  // console.log('back_to_login_text', back_to_login_text);

  //create variables for all the differnt modal sections
  var login_form_visibility = document.getElementById('login-form-visibility'),
    remember_password_form_visibility = document.getElementById('remember-password-form-visibility'),
    registration_form_visibility = document.getElementById('registration-form-visibility'),
    resend_activation_form_visibility = document.getElementById('resend-activation-form-visibility');

  // console.log('running in login modal js',back_to_login_text)

  /*
      When modal is open initialize login class
   */
  jQuery("#loginModal").on("show.bs.modal", function () {
    loginModalActivateSection('login');
  });

  /*
      When modal is closed, start back at the login section
   */

  jQuery("#loginModal").on("hidden.bs.modal", function () {
    loginModalActivateSection('login');
  });

  /*
      Add event listener for each section of the site so when the links/buttons are clicked it shows the
      correct section in the modal
   */
  if (forgot_password_link) {
    forgot_password_link.addEventListener('click', function (e) {
      //show forgot_passworf section only in modal
      loginModalActivateSection('forgot_password');
    });
  }
  if (register_account_link) {
    register_account_link.addEventListener('click', function (e) {
      //show forgot_passworf section only in modal
      loginModalActivateSection('register');
    });
  }
  if (back_to_login_text[0]) {
    //adds event listener for text in one section and then for the second section
    back_to_login_text[0].addEventListener('click', function (e) {
      //show forgot_passworf section only in modal
      loginModalActivateSection('login');
    });
  }
  if (back_to_login_text[1]) {
    back_to_login_text[1].addEventListener('click', function (e) {
      //show forgot_passworf section only in modal
      loginModalActivateSection('login');
    });
  }

  /*
      Shows the proper section in the modal by hiding and unhiding sections as necessary
       section_name: (string), the name of the section we want to make visible
     message_top: (string), we can send a message to show at the top of the register section
      for example if we want to say "you must be logged in to upvote"
     reload_page_after_login: (bool), if set to true then page will reload after login, default is true
   */
  window.loginModalActivateSection = function () {
    var section_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'login';
    var message_top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var login_without_reload_option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // console.log(' in loginModalActivateSection login_without_reload_option:',login_without_reload_option)

    if (section_name === 'forgot_password') {
      // console.log('in forgot password');
      var forgot_pass = new ModalForgotPasswordForm();
      login_form_visibility.style.display = 'none';
      remember_password_form_visibility.style.display = 'block';
      registration_form_visibility.style.display = 'none';
    } else if (section_name === 'register') {
      // console.log('in register');
      //initialize class
      var reg = new ModalRegistrationForm();
      login_form_visibility.style.display = 'none';
      remember_password_form_visibility.style.display = 'none';
      registration_form_visibility.style.display = 'block';
      // } else if(section_name === 'resend_activation'){
      //     console.log('in reset activation');
      //     //initialize class
      //     const resend_activation_form = new ResendActivationForm();
      //     login_form_visibility.style.display = 'none';
      //     remember_password_form_visibility.style.display = 'none';
      //     registration_form_visibility.style.display = 'none';
      //     resend_activation_form_visibility.style.display = 'block';
    } else if (section_name === 'login') {
      //initialize class
      // console.log('login modal class initialized')
      var login_form = new ModalLoginForm(message_top, login_without_reload_option);
      login_form_visibility.style.display = 'block';
      remember_password_form_visibility.style.display = 'none';
      registration_form_visibility.style.display = 'none';
    }
  };

  /*
      Trigger opening popup modal forgot password section directly
   */
  window.openModalForgotPassword = function () {
    jQuery("#loginModal").modal();
    loginModalActivateSection('forgot_password');
  };

  /*
      Trigger opening popup modal Register section directly
   */
  window.openModalRegister = function () {
    jQuery("#loginModal").modal();
    loginModalActivateSection('register');
  };

  /*
      Trigger opening popup modal login section directly
        message_top: (string), we can send a message to show at the top of the register section
      for example if we want to say "you must be logged in to upvote"
      reload_page_after_login: (bool), if set to true then page will reload after login, default is false
   */
  window.openModalLogin = function () {
    var message_top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var login_without_reload_option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // console.log('in openModalLogin login withour reload option:',login_without_reload_option)
    jQuery("#loginModal").modal();
    loginModalActivateSection('login', message_top, login_without_reload_option);
  };

  /*
      Trigger closing popup modal
   */
  window.closeLoginModal = function () {
    jQuery("#loginModal").modal('hide');
  };

  /*
     Shows logged in message when user logs in without reload so they are aware they have been logged into the site
  */
  window.show_logged_in_toast = function () {
    var toast_html = "\n        <div class=\"toast\" style=\"position: fixed; top: 50px; right: 10px;z-index:9999;\">\n            <div>\n                <div class=\"toast-header\">\n                    <img src=\"/wp-content/uploads/site-images/metaspoon_logo_square.png\" class=\"rounded mr-2\" height=\"20px\" width=\"20px\">\n                    <strong class=\"mr-auto\">Metaspoon Login</strong>\n                    <small>Just now</small>\n                    <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n                        <span aria-hidden=\"true\">&times;</span>\n                    </button>\n                </div>\n                <div class=\"toast-body\" style=\"background-color: #f8f8f8\">\n                    Welcome to Metaspoon! You are now logged in.\n                </div>\n            </div>\n        </div>\n    ";
    jQuery("body").append(toast_html);
    jQuery(document).ready(function () {
      jQuery('.toast').toast({
        autohide: true,
        delay: 4000
      });
      jQuery('.toast').toast('show');
    });
  };
});
/*
    Manage the registration form inside the login modal
 */
var ModalRegistrationForm = /*#__PURE__*/function () {
  function ModalRegistrationForm() {
    _classCallCheck(this, ModalRegistrationForm);
    // console.log('Registration mod initialized');

    //set option so that we log in/register without having to reload page
    this.login_without_reload_option = true;

    //set variables
    this.registrationForm = document.getElementById('mts-registration-form');
    this.registration_submit_button = document.getElementById('mts-modal-registration-submit');
    this.status = document.querySelector('[data-message="status-registration"]');
    this.registrationFormTitle = document.getElementById('login-modal-title');
    this.registrationFormEmailVerificationTitle = document.getElementById('login-modal-email-verification-title');
    this.registrationFormEmailVerificationMessage = document.getElementById('modal-registration-email-verification-message');
    this.strength_meter = document.getElementById('mts-registration-modal-strength-meter');
    this.tml_register_link = document.querySelector('[href*="/register/"]');

    //load recaptcha
    // this.recaptcha = new Recaptcha3(this.registrationForm,'recaptcha_modal_registration');

    //set event listeners
    this.setEventListeners();

    /* Load Password Strength Meter - the simple version*/
    this.registration_email = document.getElementById('registration-email').value;
    //initialize the simple version of the password meter that doesnt require a large download
    var pass_meter_params = {
      advanced_version: false,
      password_id_name: 'registration-password',
      password_confirmation_id_name: 'registration-confirm-password',
      strength_meter: this.strength_meter,
      submit_button: this.registration_submit_button,
      email: this.registration_email,
      blacklist: []
    };
    var pass_meter = new PasswordMeterImp(pass_meter_params);
  }

  /*
      Set action when user clicks on buttons in modal
   */
  return _createClass(ModalRegistrationForm, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;
      this.registrationForm.addEventListener('submit', function (e) {
        e.preventDefault();

        /*
            Run recaptcha and wait for value before logging in to make sure its not a bot
            and if its a success then continue
         */
        // this.recaptcha.execute().then( function(e){

        // console.log('xxx after recaptcha : ', e);
        _self.resetMessages();

        //sets the loading message
        _self.setLoadingMessage();

        //ajax post request
        var ajaxurl = _self.registrationForm.dataset.url;
        var referralurl = _self.registrationForm.dataset.referralurl;
        var params = new URLSearchParams(new FormData(_self.registrationForm)); //create url parameter object to send to ajax request

        //disable register button after its been pressed
        _self.registration_submit_button.value = "Logging in...";
        _self.registration_submit_button.disabled = true;

        //do ajax query to register user
        fetch(ajaxurl, {
          method: 'POST',
          body: params
        }).then(function (res) {
          return res.json();
        })["catch"](function (error) {
          console.log('error with submission - ', error);
          _self.resetMessages();
        }).then(function (response) {
          _self.resetMessages();

          // console.log('response:',response);

          if (response === 0 || !response.status) {
            var first_message;
            //if there is a single message, show that message, if its an array, show the first message in array
            if (response.message.isArray) first_message = Object.values(response.message)[0];else first_message = response.message;
            _self.status.innerHTML = first_message;
            _self.status.classList.add('text-danger');
            _self.status.classList.remove('d-none');
            _self.registration_submit_button.value = "Submit";
            return;
          }

          //if successful
          _self.status.innerHTML = response.message;
          _self.status.classList.add('success');
          _self.status.classList.add('text-success');
          _self.status.classList.remove('d-none');
          _self.registrationForm.reset();

          //hide registration title and form and display email verification message and title
          // _self.registrationForm.style.display = 'none';
          // _self.registrationFormTitle.classList.add('d-none');
          // _self.registrationFormEmailVerificationTitle.classList.remove('d-none');
          // _self.registrationFormEmailVerificationMessage.classList.remove('d-none');

          // /*
          //     Reload page after login but with 'first_login=1' parameter so we know to load welcome message
          //  */
          // let url = new URL(window.location.href);
          // let params = new URLSearchParams(url.search.slice(1));
          //
          // //Add first_login parameter
          // params.append('first_login', 1);
          // window.location.href = window.location.href + window.location.pathname + '?' + params;

          /*
              Reload the page if to log in OR do it without reloading
           */
          if (_self.login_without_reload_option !== true) {
            //reloads window and user will have been logged in
            window.location.reload();
          } else {
            //fakes all functionality to make it looks as though user is logged in without having to reload the page
            //since we dont have a display name yet, use the user_name
            window.login_without_reload(response.user_id, response.user_name, response.small_profile_image);
          }
        });
        // });
        //end recaptcha
      });
    }

    /*
        Resets status message in login modal
     */
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      this.status.innerHTML = '';
      this.status.classList.remove('success', 'error');
      this.status.classList.add('d-none'); //make status div invisible again

      //reset login button so that its clickable again
      // this.registrationForm.querySelector('[id="mts-modal-registration-submit"]').value = "Login";
      this.registrationForm.querySelector('[id="mts-modal-registration-submit"]').disabled = false;
    }

    /*
        Shows loading message in status
     */
  }, {
    key: "setLoadingMessage",
    value: function setLoadingMessage() {
      this.setStatus('<div class="spinner-border text-primary spinner-border-sm mr-1"></div>Loading...', 'loading');
    }

    /*
        Sets a message in status
          message: (string), the message we want to set in status
        type: (string), the type of message, sets the font size/color/etc
     */
  }, {
    key: "setStatus",
    value: function setStatus(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      // this.resetMessages();
      this.status.classList.remove('d-none'); //make status div invisible again
      this.status.classList.add(type);
      this.status.innerHTML = message;
    }
  }]);
}();
/*
    Manage the forgot password form inside the login modal

    https://www.tutspointer.com/custom-user-forgot-password-using-ajax-in-wordpress/
 */
domReady(function () {
  window.ModalForgotPasswordForm = /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
      console.log('Forgot password class initialized');

      //set variables
      this.forgotPassForm = document.getElementById('mts-forgot-password-form');
      this.forgot_pass_submit_button = document.getElementById('mts-modal-forgot-pass-submit');
      this.status = document.querySelector('[data-message="status-forgot-password"]');
      this.successMessage = document.getElementById('mts-forgot-password-success-message');

      //load recaptcha
      // this.recaptcha = new Recaptcha3(this.forgotPassForm,'mts_lost_password');

      //set event listeners
      this.setEventListeners();
    }

    /*
     Set action when user clicks on buttons in modal
    */
    return _createClass(_class, [{
      key: "setEventListeners",
      value: function setEventListeners() {
        var _self = this;
        this.forgotPassForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (window.debugMTS === "1") {
            console.log('xxxxxx - forgot pass event clicked', e);
          }

          /*
              Run recaptcha and wait for value before logging in to make sure its not a bot
              and if its a success then continue
           */
          // _self.recaptcha.execute().then( function(e){

          if (window.debugMTS === "1") {
            console.log('xxxxxx - RECAPTCHA ran:', e);
          }

          //clears status message
          _self.resetMessages();

          //set loading message
          _self.setLoadingMessage();
          var ajaxurl = _self.forgotPassForm.dataset.url;
          var params = new URLSearchParams(new FormData(_self.forgotPassForm)); //create url parameter object to send to ajax request
          if (window.debugMTS === "1") {
            console.log('params:', params);
          }

          //disable register button after its been pressed
          _self.forgot_pass_submit_button.value = "Reseting Password...";
          _self.forgot_pass_submit_button.disabled = true;
          if (window.debugMTS === "1") {
            console.log('params:', params.toString());
          }

          //do ajax query to password reset
          fetch(ajaxurl, {
            method: 'POST',
            body: params
          }).then(function (res) {
            return res.json();
          })["catch"](function (error) {
            console.log('error with submission - ', error);
            _self.resetMessages();
          }).then(function (response) {
            _self.resetMessages();
            _self.forgot_pass_submit_button.disabled = false;
            //console.log('response:',response);

            if (response === 0 || !response.status) {
              _self.setStatus(response.message, 'error');
              return;
            }
            _self.setStatus(response.message, 'success');
            _self.forgotPassForm.classList.add('d-none');
            _self.successMessage.classList.remove('d-none');
            _self.forgotPassForm.reset();

            // window.location.reload();
          });

          // });
          //end recaptcha
        });
      }

      /*
          Sets a message in status
            message: (string), the message we want to set in status
          type: (string), the type of message, sets the font size/color/etc
       */
    }, {
      key: "setStatus",
      value: function setStatus(message) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
        this.resetMessages();
        this.status.classList.remove('d-none'); //make status div invisible again
        this.status.classList.add(type);
        this.status.innerHTML = message;
      }

      /*
          Resets status message in modal
       */
    }, {
      key: "resetMessages",
      value: function resetMessages() {
        this.status.innerHTML = '';
        this.status.classList.remove('success', 'error', 'loading');
        this.status.classList.add('d-none'); //make status div invisible again
      }

      /*
      Shows loading message in status
      */
    }, {
      key: "setLoadingMessage",
      value: function setLoadingMessage() {
        if (window.debugMTS === "1") {
          console.log('in set loading message');
        }
        this.setStatus('<div class="spinner-border text-primary spinner-border-sm mr-1"></div>Loading...', 'loading');
      }
    }]);
  }();

  // const forgot_pass = new ModalForgotPasswordForm();
});
/*
    Manage the login form inside the login modal
 */
var ModalLoginForm = /*#__PURE__*/function () {
  /*
      message_top: (string), we can send a message to show at the top of the register section
          for example if we want to say "you must be logged in to upvote"
      login_without_reload_option: (bool), if set to true, then page does not reload when login in, otherwise it does, default is true
   */

  function ModalLoginForm() {
    var message_top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var login_without_reload_option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _classCallCheck(this, ModalLoginForm);
    //set option so that we log in/register without having to reload page
    this.login_without_reload_option = login_without_reload_option;

    // console.log('in ModalLoginForm class- login_without_reload_option:',this.login_without_reload_option)

    //create all the link variables for the differnt sections
    this.message_top_text = document.getElementById('login-modal-message-top'); //message at top of login section (ie."you must be logged in to upvote")
    this.forgot_password_link = document.getElementById('login-modal-forgot-pass');
    this.register_account_link = document.getElementById('login-modal-register-account');
    this.back_to_login_text = document.getElementsByClassName('login-modal-back-to-login-text');
    this.loginForm = document.getElementById('mts-login-form'); //the whole login form
    this.status = this.loginForm.querySelector('[data-message="status"]'); //the status div
    this.nonce = this.loginForm.querySelector('[id="mts_modal_login_nonce"]').value; //nonce for form

    //set a message at the top of if set one
    if (message_top != null) {
      this.message_top_text.innerHTML = message_top;
      this.message_top_text.style.display = "block";
    }

    // For Reset-Password page specifically checks if we have a redirect url in the log in button
    // and sets the variable if its exists
    this.reset_password_page_login = document.getElementById('mts-reset-password-form-login-button');
    if (this.reset_password_page_login) {
      this.redirect_url = this.reset_password_page_login.getAttribute('data-redirect-url');
      //console.log('redirect url:',this.redirect_url);
    }

    //get redirect url for email confirmation
    this.email_confirmation_login_button = document.getElementById('mts-email-activation-page-login-button');
    if (this.email_confirmation_login_button) {
      this.redirect_url = this.email_confirmation_login_button.getAttribute('data-redirect-url');
      //console.log('redirect url:',this.redirect_url);
    }

    //set variables
    this.ajaxurl = this.loginForm.dataset.url;
    //load google login class
    var google_login = new GoogleLogin(this.ajaxurl, this.nonce, this.login_without_reload_option);
    var fb_login = new FbLogin(this.ajaxurl, this.nonce, this.login_without_reload_option);

    //set event listeners
    this.setEventListeners();

    //load recaptcha script
    // this.recaptcha = new Recaptcha3(this.loginForm,'mts_login');
  }

  /*
      Set action when user clicks on buttons in modal
   */
  return _createClass(ModalLoginForm, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;

      /*
          Action when user submits the login modal
       */
      this.loginForm.addEventListener('submit', function (e) {
        // console.log('xxxxx - event for for login clicked');
        e.preventDefault();

        /*
            Run recaptcha and wait for value before logging in to make sure its not a bot
            and if its a success then continue
         */
        // this.recaptcha.execute().then( function(e){

        // console.log('recaptcha results:', e);

        //reset the form messages then load loading message
        _self.resetMessages();
        _self.setLoadingMessage();

        //collect form data
        var data = {
          name: _self.loginForm.querySelector('[id="username"]').value,
          password: _self.loginForm.querySelector('[id="password"]').value,
          nonce: _self.nonce
        };

        //validate everything
        if (!data.name || !data.password) {
          _self.status.innerHTML = 'Missing information';
          _self.status.classList.add('error');
          return;
        }

        //ajax post request
        var params = new URLSearchParams(new FormData(_self.loginForm)); //create url parameter object to send to ajax request

        //disable login button after its been pressed
        _self.loginForm.querySelector('[id="mts-login-modal-submit"]').value = "Logging in...";
        _self.loginForm.querySelector('[id="mts-login-modal-submit"]').disabled = true;

        // Display the values
        console.log('Values for loginForm');
        var _iterator = _createForOfIteratorHelper(params.values()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var value = _step.value;
            console.log('value:', value);
          }

          //do ajax query to log in
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        fetch(_self.ajaxurl, {
          method: 'POST',
          body: params
        }).then(function (res) {
          return res.text();
        }).then(function (response) {
          /*
              Before we parse to json, we first check the text to see if wordpress security has locked
              us out. We read the ajax return string to see if it returned an error page telling
              us the user is locked out.
           */

          //check if user has been locked out
          if (_self.isUserLockedOut(response)) {
            console.log('user has been locked out');
            _self.setStatus('<strong>Error</strong>: You tried to log in too many tries and are now locked out for 15 minutes. If this doesn\'t work please reach us on our contact page .', 'error');
            return "locked_out";
          } else {
            return response;
          }
        })
        // .then(res => res.json())
        ["catch"](function (error) {
          // console.log('error with submission - ', error);
          // _self.resetMessages();
        }).then(function (response) {
          //if the user was locked out above, then skip this function
          if (response === "locked_out") return;
          _self.resetMessages();

          //convert JSON text to a json for js to read
          response = JSON.parse(response);
          if (response === 0 || !response.status) {
            _self.setStatus(response.message, 'error');
            return;
          }
          _self.setStatus(response.message, 'success');
          _self.loginForm.reset();

          //if we have a redirect url then go there, otherwise just reload page after login
          if (_self.redirect_url) {
            window.location.href = _self.redirect_url;
            //console.log('redirecting to ', _self.redirect_url);
          } else {
            /*
                Reload the page if to log in OR do it without reloading
             */
            if (_self.login_without_reload_option !== true) {
              //reloads window and user will have been logged in
              window.location.reload();
            } else {
              console.log('XXXX running login wihtout reload!');
              //fakes all functionality to make it looks as though user is logged in without having to reload the page
              window.login_without_reload(response.user_id, response.user_name, response.small_profile_image, response.display_name);

              /*
                  Run bootstrap 4 toast to let the user know they are now logged into the site
               */
              window.show_logged_in_toast();
            }
          }
        });

        // });
        //end recaptcha
      });
    }

    /*
        Looks at the reponse to see if the user has been locked out by looking at the html outputted
        from the security plugin and looks for the text "lock_out_screen", meaning the user has been locked out
     */
  }, {
    key: "isUserLockedOut",
    value: function isUserLockedOut(response) {
      //if the reponse contains the text "lock_out_screen" it means user is locked out so return true
      if (response.includes("lock_out_screen")) {
        //console.log('lock out screen included!')
        return true;
      }
      //console.log('lock out screen NOT included..')
      return false;
    }

    /*
        Resets status message in login modal
     */
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      this.status.innerHTML = '';
      this.status.classList.remove('success', 'error', 'loading');
      this.status.classList.add('d-none'); //make status div invisible again

      this.loginForm.querySelector('[id="mts-login-modal-submit"]').value = "Login";
      this.loginForm.querySelector('[id="mts-login-modal-submit"]').disabled = false;
    }

    /*
        Shows loading message in status
     */
  }, {
    key: "setLoadingMessage",
    value: function setLoadingMessage() {
      this.setStatus('<div class="spinner-border text-primary spinner-border-sm mr-1"></div>Loading...', 'loading');
    }

    /*
        Sets a message in status
          message: (string), the message we want to set in status
        type: (string), the type of message, sets the font size/color/etc
     */
  }, {
    key: "setStatus",
    value: function setStatus(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      this.resetMessages();
      this.status.classList.remove('d-none'); //make status div invisible again
      this.status.classList.add(type);
      this.status.innerHTML = message;
    }
  }]);
}();
/*
    Runs re-captcha
    https://www.google.com/recaptcha/admin/site/430823345/setup
    https://developers.google.com/recaptcha/docs/v3
    https://code.tutsplus.com/tutorials/example-of-how-to-add-google-recaptcha-v3-to-a-php-form--cms-33752
 */
var Recaptcha3 = /*#__PURE__*/function () {
  /*
      form_to_attach_to: (object), the form js object onto which we will attach the captcha
      recaptcha_action_name: (string), the name of the action for which we are running the captcha (ie. register_button)
   */
  function Recaptcha3(form_to_attach_to, recaptcha_action_name) {
    _classCallCheck(this, Recaptcha3);
    // console.log('recaptcha constructor');
    //create class variables
    this.form_to_attach_to = form_to_attach_to;
    this.recaptcha_action_name = recaptcha_action_name;
    this.site_key = '6Lex160ZAAAAAPePmFYL-IYSkiJ4ly0w_bpv_Wzd';

    //load recaptcha file from google and initiate
    this.loadRecaptcha3();
  }
  /*
      Once captcha files from google are loaded, it adds hidden fields to registration form
        form_to_attach_to: (object), the form js object onto which we will attach the captcha
      action_name: (string), the name of the action for which we are running the captcha (ie. register_button)
   */
  return _createClass(Recaptcha3, [{
    key: "execute",
    value: function execute() {
      var _self = this;
      return new Promise(function (resolve, reject) {
        //first check that re-captcha is succesfull
        // console.log('this.site_key:',this.site_key, 'this.action_name:',this.action_name)
        grecaptcha.ready(function () {
          /*
              When the user submits execute the captcha in order to avoid timeout by executing too early
           */
          grecaptcha.execute(_self.site_key, {
            action: _self.recaptcha_action_name
          }).then(function (token) {
            // console.log('token', token);

            //first check if we already have a recaptcha field created (if we tried to log in already, and delete it)
            var existing_token_field = document.getElementsByName("token")[0];
            // const existing_token_field = document.getElementsByName("token")[0];
            if (typeof existing_token_field !== 'undefined') {
              // console.log('exisintg toekn field:',existing_token_field);
              existing_token_field.remove();
            }

            // then create a new recaptch v3 hidden input fields and add them to form
            var input_token = document.createElement("input");
            input_token.setAttribute('type', 'hidden');
            input_token.setAttribute('name', 'token');
            input_token.setAttribute('value', token);

            //Dont need to add hidden action, just attaching token works
            // const input_action = document.createElement("input");
            // input_action.setAttribute('type', 'hidden')
            // input_action.setAttribute('name', 'action')
            // input_action.setAttribute('value', _self.recaptcha_action_name);

            _self.form_to_attach_to.insertBefore(input_token, _self.form_to_attach_to.firstChild);
            // _self.form_to_attach_to.insertBefore(input_action, _self.form_to_attach_to.firstChild);
            // form_to_attach_to.unbind('submit').submit();
          }).then(function () {
            resolve("token added");
          });
        });
      });
    }

    /*
        Load the recaptcha 3 js files from google and run initialize function once it loaded
     */
  }, {
    key: "loadRecaptcha3",
    value: function loadRecaptcha3() {
      var _self = this;
      var recaptcha_script = document.createElement('script');
      recaptcha_script.onload = function () {
        //do stuff with the script
        // _self.initRecaptcha();
      };
      recaptcha_script.src = 'https://www.google.com/recaptcha/api.js?render=' + this.site_key;

      //if google recaptcha js script hasnt already been loaded then load it
      if (this.isScriptAlreadyIncluded(recaptcha_script.src) === false) document.head.appendChild(recaptcha_script); //or something of the likes
    }

    /*
        Check if a script has already been included
     */
  }, {
    key: "isScriptAlreadyIncluded",
    value: function isScriptAlreadyIncluded(src) {
      var scripts = document.getElementsByTagName("script");
      for (var i = 0; i < scripts.length; i++) if (scripts[i].getAttribute('src') == src) return true;
      return false;
    }
  }]);
}();
/*
    Class containing functionality for Google Login

    https://developers.google.com/identity/sign-in/web/build-button
 */
var GoogleLogin = /*#__PURE__*/function () {
  /*
      ajaxurl: (string), the wordpress ajax url
      nonce: (string), the nonce for ajax security
      setStatusObject: (object), sets the status message
   */
  function GoogleLogin(ajaxurl, nonce) {
    var login_without_reload_option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, GoogleLogin);
    this.login_without_reload_option = login_without_reload_option; //if set to true, login will no reload the page
    // console.log('in GoogleLogin class - this.login_without_reload_option : ',this.login_without_reload_option )

    this.loginForm = document.getElementById('mts-login-form'); //the whole login form
    this.status = this.loginForm.querySelector('[data-message="status"]'); //the status div
    this.google_login_button = document.getElementById('login-modal-google-signin');
    this.ajaxurl = ajaxurl;
    this.nonce = nonce;

    //load and initialize all the necessary files for google login
    this.loadGoogleLoginFiles();

    /* set event listener for google button to set status */
    this.setEventListeners();
  }
  return _createClass(GoogleLogin, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      //set loading status message when google button is clicked
      this.google_login_button.addEventListener('click', function (e) {
        e.preventDefault();
        _this2.resetMessages();
        _this2.setLoadingMessage();
      });
    }

    /*
        Load the files from google and run initialize function once it loaded
     */
  }, {
    key: "loadGoogleLoginFiles",
    value: function loadGoogleLoginFiles() {
      var _self = this;

      //add meta tag to header
      //<meta name="google-signin-client_id" content="YOUR_CLIENT_ID.apps.googleusercontent.com">
      var googlesignin_script = document.createElement('script');
      //once google js is loaded initialize the api
      googlesignin_script.onload = function () {
        gapi.load('auth2', function () {
          /* Ready. Make a call to gapi.auth2.init or some other API */
          var params = {
            client_id: "352053357253-j0h0q67829uea4u9cj54f5dphe4nfndv.apps.googleusercontent.com"
          };
          var auth2 = gapi.auth2.init(params);
          _self.attachSignin(auth2, _self.google_login_button);
        });
      };
      googlesignin_script.src = 'https://apis.google.com/js/platform.js';
      document.head.appendChild(googlesignin_script); //or something of the likes
    }

    /*
        This function attaches the google api to button, so that when user clicks
        on the google button in the form it logs user in.
          If succesful it then calls the function necessary to log in or register as necessary
          auth2: (object), contains api functionality
        element: (object), google login button element from form
     */
  }, {
    key: "attachSignin",
    value: function attachSignin(auth2, element) {
      var _self = this;
      auth2.attachClickHandler(element, {}, function (googleUser) {
        // console.log('auth2 in attachclickgandler function:',auth2)
        var google_user_data = [];
        google_user_data['id_token'] = googleUser.getAuthResponse().id_token;
        _self.loginWithGoogle(google_user_data, _self.ajaxurl, _self.nonce); //returns a message to update status
      }, function (error) {
        /*
            Hide popup alert error
         */
        // alert(JSON.stringify(error, undefined, 2));
        //console.log('google login error:',JSON.stringify(error, undefined, 2));
        //if we couldnt log in then remove the loading message and give error instead
        _self.resetMessages();
        //console.log(error.error);
        if (error.error == "popup_closed_by_user") {
          _self.setStatus('Error: You closed the google login window, please try again.', 'error');
        } else {
          _self.setStatus('Error: Failed login into google - please contact an admin with this error message - ' + error.error, 'error');
        }
      });
    }

    /*
        Connects to php api to perform ajax call in order to send variables from google api to wordpress
        in order to log in/create account as necessary
          user_data: (array), contains user data for login/register
     */
  }, {
    key: "loginWithGoogle",
    value: function loginWithGoogle(user_data, ajaxurl, nonce) {
      var _this3 = this;
      var _self = this;
      var params_object = {};
      params_object.action = 'mts_google_login';
      params_object.referrer_url = window.location.href;
      params_object.mts_google_nonce = nonce;
      if (user_data.id_token != undefined) params_object.id_token = user_data.id_token;

      // user_data
      var params = new URLSearchParams(params_object); //create url parameter object to send to ajax request

      //do ajax query to log in
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        console.log('error with submission - ', error);
        // this.resetMessages();
      }).then(function (response) {
        _this3.resetMessages();
        if (response === 0 || !response.status) {
          _this3.setFailureMessage(response.message);
          return;
        }
        _this3.resetMessages();
        _this3.setSuccessMessage();

        /*
            Reload the page if to log in OR do it without reloading
         */
        if (_self.login_without_reload_option !== true) {
          //reloads window and user will have been logged in
          window.location.reload();
        } else {
          //fakes all functionality to make it looks as though user is logged in without having to reload the page
          window.login_without_reload(response.user_id, response.user_name, response.small_profile_image, response.display_name);

          /*
              Run bootstrap 4 toast to let the user know they are now logged into the site
           */
          window.show_logged_in_toast();
        }
      });
    }

    /*
        Shows loading message in status
     */
  }, {
    key: "setLoadingMessage",
    value: function setLoadingMessage() {
      this.setStatus('<div class="spinner-border text-primary spinner-border-sm mr-1"></div>Loading...', 'loading');
    }

    /*
        Shows success message in status
     */
  }, {
    key: "setSuccessMessage",
    value: function setSuccessMessage() {
      this.setStatus('Succesfully logged in!', 'success');
    }

    /*
        Shows success message in status
     */
  }, {
    key: "setFailureMessage",
    value: function setFailureMessage(message) {
      this.setStatus("Failed to log in with Google - ".concat(message), 'error');
    }

    /*
        Sets a message in status
          message: (string), the message we want to set in status
        type: (string), the type of message, sets the font size/color/etc
     */
  }, {
    key: "setStatus",
    value: function setStatus(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      // this.resetMessages();
      this.status.classList.remove('d-none'); //make status div invisible again
      this.status.classList.add(type);
      this.status.innerHTML = message;
    }

    /*
        Resets status message in modal
     */
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      this.status.innerHTML = '';
      this.status.classList.remove('success', 'error', 'loading');
      this.status.classList.add('d-none'); //make status div invisible again
    }
  }]);
}();
/*
    Class containing functionality for Facebook Login

    https://developers.facebook.com/docs/facebook-login/web
    https://developers.facebook.com/docs/javascript/reference/FB.api/
 */
var FbLogin = /*#__PURE__*/function () {
  /*
      ajaxurl: (string), the wordpress ajax url
      nonce: (string), the nonce for ajax security
   */
  function FbLogin(ajaxurl, nonce) {
    var login_without_reload_option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, FbLogin);
    this.login_without_reload_option = login_without_reload_option; //if set to true, login will no reload the page
    // console.log('Loginw withour reload value:',this.login_without_reload_option)

    this.loginForm = document.getElementById('mts-login-form'); //the whole login form
    this.status = this.loginForm.querySelector('[data-message="status"]'); //the status div
    this.fb_login_button = document.getElementById('login-modal-fb-signin');
    this.ajaxurl = ajaxurl;
    this.nonce = nonce;

    //load and initialize all the necessary files for google login
    this.loadFbLoginFiles();

    /* set event listener for google button to set status */
    this.setEventListeners();
  }
  return _createClass(FbLogin, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this4 = this;
      //set loading status message when google button is clicked
      this.fb_login_button.addEventListener('click', function (e) {
        e.preventDefault();

        //not sure if its necessary
        window.fbAsyncInit = function () {
          FB.init({
            appId: '480548228817507',
            //internal reports
            cookie: true,
            // This is important, it's not enabled by default
            xfbml: true,
            version: 'v3.3'
          });
        };
        FB.login(function (response) {
          // handle the response
          if (response.status === 'connected') {
            // Logged into your webpage and Facebook.
            //console.log('FB connected to site... login into FB succesful.')
            _self.loginWithFb(_self.ajaxurl, _self.nonce);
          } else {
            // The person is not logged into your webpage or we are unable to tell.
            //console.log('Login access not given...',response.status);
            if (response.status === "unknown") {
              _self.setStatus('Error: Please try logging into Facebook again.', 'error');
            }
          }
        }, {
          scope: 'public_profile,email',
          auth_type: 'rerequest'
        });
        var _self = _this4;
        _self.resetMessages();
        _self.setLoadingMessage();
      });
    }

    /*
        After we are connected to the facebook api get all necessary fields and make ajax calls
     */
  }, {
    key: "loginWithFb",
    value: function loginWithFb(ajaxurl, nonce) {
      var _self = this;
      var fb_email; //email address provided by facebook sdk
      var fb_id; //email address provided by facebook sdk
      var fb_name; //email address provided by facebook sdk
      var access_token; //access token provided by facebook sdk

      /*
          Connect to FB Api get get email, user id, etc
       */
      //Check that we have access to user's email, otherwise give an error
      FB.api('/me', {
        fields: 'email,id,name'
      }, function (response) {
        fb_email = response.email;
        fb_id = response.id;
        fb_name = response.name;
        access_token = FB.getAuthResponse()['accessToken'];

        /*
            Do error checking to make sure we have all necessary variables
         */
        if (!fb_email) {
          _self.resetMessages();
          _self.setStatus('You must give access to email to sign up, please try again.', 'error');
          return;
        }
        if (!fb_id) {
          _self.resetMessages();
          _self.setStatus('Couldnt retrieve fb user id.', 'error');
          return;
        }
        if (!access_token) {
          _self.resetMessages();
          _self.setStatus('We could not get fb access token.', 'error');
          return;
        }

        /*
            Run ajax call to php to check if user token is valid and login/register as necessary
         */
        var params_object = {};
        params_object.action = 'mts_fb_login';
        params_object.referrer_url = window.location.href;
        params_object.mts_fb_nonce = nonce;
        params_object.access_token = access_token;
        params_object.email = fb_email;
        params_object.id = fb_id;
        params_object.name = fb_name;
        var params = new URLSearchParams(params_object); //create url parameter object to send to ajax request

        //do ajax query to log in
        fetch(ajaxurl, {
          method: 'POST',
          body: params
        }).then(function (res) {
          return res.json();
        })["catch"](function (error) {
          // this.resetMessages();
        }).then(function (response) {
          _self.resetMessages();
          if (response === 0 || !response.status) {
            _self.setStatus("Login with FB failed - ".concat(response.message), 'error');
            return;
          }
          _self.resetMessages();
          _self.setStatus('Thanks for logging in! ', 'success');
          // console.log('fb_email',fb_email);
          // console.log('access_toekn:',params_object.access_token)

          /*
              Reload the page if to log in OR do it without reloading
           */
          if (_self.login_without_reload_option !== true) {
            //reloads window and user will have been logged in
            window.location.reload();
          } else {
            //fakes all functionality to make it looks as though user is logged in without having to reload the page
            window.login_without_reload(response.user_id, response.user_name, response.small_profile_image, response.display_name);

            /*
                Run bootstrap 4 toast to let the user know they are now logged into the site
             */
            window.show_logged_in_toast();
          }
        });

        // FB.api('/me', function(response) { //no need to do 2 requests... we already have the user's name
        _self.resetMessages();
        _self.setStatus('Thanks for logging in, ' + fb_name + '!', 'success');
        //console.log('Thanks for logging in ' + fb_name);
        // });
      });
    }

    /*
        Load the files from google and run initialize function once it loaded
     */
  }, {
    key: "loadFbLoginFiles",
    value: function loadFbLoginFiles() {
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.3&appId=480548228817507";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');

      // const _self = this;
      // const fblogin_script = document.createElement('script');
      //
      // //once google js is loaded initialize the api
      // fblogin_script.onload = function () {
      //
      //
      // };
      // fblogin_script.src = 'https://connect.facebook.net/en_US/sdk.js';
      //
      // document.head.appendChild(fblogin_script); //or something of the likes
    }

    /*
        Shows loading message in status
     */
  }, {
    key: "setLoadingMessage",
    value: function setLoadingMessage() {
      this.setStatus('<div class="spinner-border text-primary spinner-border-sm mr-1"></div>Loading...', 'loading');
    }

    /*
        Shows success message in status
     */
  }, {
    key: "setSuccessMessage",
    value: function setSuccessMessage() {
      this.setStatus('Succesfully logged in!', 'success');
    }

    /*
        Shows success message in status
     */
  }, {
    key: "setFailureMessage",
    value: function setFailureMessage() {
      this.setStatus('Failed to log in with Google', 'error');
    }

    /*
        Sets a message in status
          message: (string), the message we want to set in status
        type: (string), the type of message, sets the font size/color/etc
     */
  }, {
    key: "setStatus",
    value: function setStatus(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      // this.resetMessages();
      this.status.classList.remove('d-none'); //make status div invisible again
      this.status.classList.add(type);
      this.status.innerHTML = message;
    }

    /*
        Resets status message in modal
     */
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      this.status.innerHTML = '';
      this.status.classList.remove('success', 'error', 'loading');
      this.status.classList.add('d-none'); //make status div invisible again
    }
  }]);
}();
/*
    This class implements the wordpress password meter so that its easy to use
 */
window.PasswordMeterImp = /*#__PURE__*/function () {
  /*
      Trigger the password meter
   */
  function _class2(params) {
    _classCallCheck(this, _class2);
    // console.log('Password Meter Imp class initialized');
    if (params.advanced_version === true) this.AdvancedWPPasswordStrengthMeter(params.password_id_name, params.password_confirmation_id_name, params.strength_meter, params.submit_button, params.blacklistArray);else this.SimplePasswordStrengthMeter(params.password_id_name, params.password_confirmation_id_name, params.strength_meter, params.submit_button, params.email);
  }

  /*
      Run the WP Advanced strength meter when user types in the password boxes.
      Requires large files, and enqueueing the wp password meter and zxcvbn which is quite large
      so we should only do it if we really need an advanced version.
        pass1_id_name: (string), the id of the password input
      pass2_id_name: (string), the id of the password confirmation input
      strength_meter: (string), the div tag which contains the password strngth meter
      submit_button: (string), the id of the submit button which will be disabled/enabled if password is string enough
      blacklistArray: (array), contains strings of words that are blacklisted as passwords
   */
  return _createClass(_class2, [{
    key: "AdvancedWPPasswordStrengthMeter",
    value: function AdvancedWPPasswordStrengthMeter(pass1_id_name, pass2_id_name, strength_meter, submit_button) {
      var blacklistArray = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var pwsL10n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var _self = this;

      //disable the submit button by default
      submit_button.disabled = true;

      //set all the text result variables for the password meter
      if (pwsL10n === null) {
        pwsL10n = {
          "empty": "Strength indicator",
          "short": "<strong>Password is weak<\/strong> - please make it longer with lower and uppercase characters.",
          "bad": "<strong>Password is bad<\/strong> - please make it longer with lower and uppercase characters.",
          "good": "<strong>Password is OK<\/strong> - but we'd recommend you make it a little longer.",
          "strong": "<strong>Password is GREAT!<\/strong>",
          "mismatch": "<strong>Mismatch<\/strong> - passwords don't match."
        };
      }

      //create blacklist array and extend with site's blacklist array
      blacklistArray = blacklistArray.concat(wp.passwordStrength.userInputBlacklist());
      // console.log('blacklistArray:',blacklistArray);

      // trigger the wdmChkPwdStrength
      $('body').on('keyup', "input[name=".concat(pass1_id_name, "], input[name=").concat(pass2_id_name, "]"), function (event) {
        var pass1 = document.getElementById(pass1_id_name).value;
        var pass2 = document.getElementById(pass2_id_name).value;

        // Get the password strength
        var strength = wp.passwordStrength.meter(pass1, blacklistArray, pass2);
        // console.log('strength:',strength);
        // console.log('pass1:',pass1);
        // console.log('pass2:',pass2);
        // console.log('blacklistArray:',blacklistArray);

        // Reset the form & meter
        _self.resetStrengthMeter(strength_meter);

        // The meter function returns a result even if pass2 is empty,
        // enable only the submit button if the password is strong and
        // both passwords are filled up
        if ((strength === 3 || strength === 4) && pass2.trim() != '') {
          submit_button.disabled = false;
        } else {
          submit_button.disabled = true;
        }

        // Add the strength meter results
        switch (strength) {
          case 2:
            strength_meter.classList.add('bad', 'alert-danger');
            strength_meter.innerHTML = pwsL10n.bad;
            strength_meter.classList.remove('d-none');
            break;
          case 3:
            strength_meter.classList.add('good', 'alert-primary');
            strength_meter.innerHTML = pwsL10n.good;
            strength_meter.classList.remove('d-none');
            break;
          case 4:
            strength_meter.classList.add('strong', 'alert-success');
            strength_meter.innerHTML = pwsL10n.strong;
            strength_meter.classList.remove('d-none');
            break;
          case 5:
            strength_meter.classList.add('short', 'alert-danger');
            strength_meter.innerHTML = pwsL10n.mismatch;
            strength_meter.classList.remove('d-none');
            break;
          default:
            strength_meter.classList.add('short', 'alert-danger');
            strength_meter.innerHTML = pwsL10n["short"];
            strength_meter.classList.remove('d-none');
        }
      });
    }

    /*
        Resets the strength meter visibility and colors
     */
  }, {
    key: "resetStrengthMeter",
    value: function resetStrengthMeter(strength_meter) {
      strength_meter.classList.add('d-none');
      strength_meter.classList.remove('short', 'bad', 'good', 'strong');
      strength_meter.classList.remove('alert-danger', 'alert-primary', 'alert-success', 'alert-warning');
    }

    /*
        Custom made password meter that is simple and doesnt require the advanced password meter.
     */
  }, {
    key: "SimplePasswordStrengthMeter",
    value: function SimplePasswordStrengthMeter(pass1_id_name, pass2_id_name, strength_meter, submit_button, email) {
      var _self = this;
      // console.log('in simple password meter');

      //disable the submit button by default
      submit_button.disabled = true;

      // trigger the password check every time user presses in passwords input boxes
      jQuery('body').on('keyup', "input[name=".concat(pass1_id_name, "], input[name=").concat(pass2_id_name, "]"), function (event) {
        var pass1 = document.getElementById(pass1_id_name).value;
        var pass2 = document.getElementById(pass2_id_name).value;

        // Get the password strength
        var strength = _self.getSimpleStrengthScore(pass1, pass2, email);

        // Reset the form & meter
        _self.resetStrengthMeter(strength_meter);

        // The meter function returns a result even if pass2 is empty,
        // enable only the submit button if the password is strong and
        // both passwords are filled up
        if (strength === "success") {
          submit_button.disabled = false;
        } else {
          submit_button.disabled = true;
        }

        // Add the strength meter results
        switch (strength) {
          case "short":
            strength_meter.classList.add('short', 'alert-danger');
            strength_meter.innerHTML = "<strong>Password is too short</strong> - it must be at least 8 characters.";
            strength_meter.classList.remove('d-none');
            break;
          case "uppercase":
            strength_meter.classList.add('good', 'alert-danger');
            strength_meter.innerHTML = "<strong>Password is weak </strong> - must have at least one uppercase and one lowercase letter.";
            strength_meter.classList.remove('d-none');
            break;
          case "must_contain_letters":
            strength_meter.classList.add('good', 'alert-danger');
            strength_meter.innerHTML = "<strong>Password is weak </strong> - must contain at least one letter.";
            strength_meter.classList.remove('d-none');
            break;
          case "must_contain_uppercase_number_or_symbol":
            strength_meter.classList.add('good', 'alert-danger');
            strength_meter.innerHTML = "<strong>Password is weak </strong> - must contain at least one uppercase letter, number or symbol.";
            strength_meter.classList.remove('d-none');
            break;
          case "number_or_symbol":
            strength_meter.classList.add('good', 'alert-danger');
            strength_meter.innerHTML = "<strong>Password is weak </strong> - must have at least one number or a symbol like: ! # $ % ^ &.";
            strength_meter.classList.remove('d-none');
            break;
          case "email":
            strength_meter.classList.add('strong', 'alert-danger');
            strength_meter.innerHTML = "Password can\'t be the same as your email.";
            strength_meter.classList.remove('d-none');
            break;
          case "mismatch":
            strength_meter.classList.add('short', 'alert-danger');
            strength_meter.innerHTML = "Password and password confirmation don't match.";
            strength_meter.classList.remove('d-none');
            break;
          case "success":
            strength_meter.classList.add('success', 'alert-success');
            strength_meter.innerHTML = "Password looks good!";
            strength_meter.classList.remove('d-none');
            break;
          default:
            strength_meter.classList.add('short', 'alert-danger');
            strength_meter.innerHTML = "<strong>Password is too short</strong> - it must be at least 8 characters.";
            strength_meter.classList.remove('d-none');
        }
      });
    }

    /*
        Simple script to get password strength
        Checks:
            -at least 8 characters in password
            -needs lowercase and at least one uppercase, number or special character
            -checks pass is not same as email
            -checks pass and confirmation match
         returns: (string), 'success' if it passes, else it returns the name of the error
     */
  }, {
    key: "getSimpleStrengthScore",
    value: function getSimpleStrengthScore(pass1, pass2, email) {
      if (pass1.length < 8) return "short"; //check if password is too short

      //check that password contains letters (A-Z or a-z)
      if (!this.hasLetter(pass1)) return "must_contain_letters";

      //check that password contains at least one uppercase, number or symbol
      if (!this.hasUpperCase(pass1) && !this.hasSymbol(pass1) && !this.hasNumber(pass1)) return "must_contain_uppercase_number_or_symbol";

      // if(!this.hasSymbol(pass1) && !this.hasNumber(pass1) ) return "number_or_symbol";
      //check that password has lowercase and at least one capital, number or special character

      //check passowrd is not same as email
      if (pass1 === email) return "email";
      //check passwords match
      if (pass1 !== pass2) return "mismatch";

      //if no errors then return success
      return "success";
    }

    /*
        Checks if there is at least one uppercase
          stringToCheck: (string), the string we are checking for uppercase letters
          returns: (bool), true if there is uppercase and false if there is not an uppercase
     */
  }, {
    key: "hasUpperCase",
    value: function hasUpperCase() {
      var stringToCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      //if string is identical as the same string converted to lowercase, then there are no uppercase
      if (stringToCheck === stringToCheck.toLowerCase()) return false;

      //otherwise return true as there must be uppercase letters
      return true;
    }

    /*
        If there is a symbol (! " ? $ % ^ &) in string it returns true
          returns: (bool), if there is a symbol in string, else false
     */
  }, {
    key: "hasSymbol",
    value: function hasSymbol(stringToCheck) {
      var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
      if (format.test(stringToCheck)) {
        return true;
      } else {
        return false;
      }
    }

    /*
    If there is a symbol in string it returns true
      returns: (bool), if there is a number in string, else false
    */
  }, {
    key: "hasNumber",
    value: function hasNumber(stringToCheck) {
      var format = /[123456789]+/;
      if (format.test(stringToCheck)) {
        return true;
      } else {
        return false;
      }
    }

    /*
        If there is a letter in string it returns true
          returns: (bool), if there is a letter in string, else false
        */
  }, {
    key: "hasLetter",
    value: function hasLetter(stringToCheck) {
      var letters = /[A-Za-z]/;
      if (stringToCheck.match(letters)) {
        return true;
      } else {
        return false;
      }
    }
  }]);
}();

/*
    Runs all necessary functionality to log user in without having to reload the window

    *** Will trigger an event ('logged_in_without_reload') so other js can detect when we have logged in without a reload ***

    user_id: (int), the user id of user that just logged in
    user_name: (string), the name of the user id that just logged in
    small_profile_image: (string), the small profile image url of the user id that just logged in
    display_name: (string), the nickname or display name chosen by the user (defaults to username)

    NOTE: We CANT DO LOGIN NONCE from there, because if we try to create the logged_in_nonce from the login script,
    it will not yet have the session id for some reason when creating the nonce and will create a difference nonce. We need
    a new php query (ie. in the top navigation ajax query) to create a new nonce that will have session id in it

 */
window.login_without_reload = function (user_id, user_name) {
  var small_profile_image = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var display_name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  /*
      If the display name is blank then use the user_name as the display name
   */
  if (display_name === "") display_name = user_name;

  // console.log('in login without reload function');
  // console.log('displayname:',display_name);
  // console.log('user_name:',user_name);
  /*
      Event listener to detect when loggin without reload occured
   */
  document.addEventListener("logged_in_without_reload_event", function (e) {
    //console.log('IN LOGING WITHOUT RELOAD - > Weve logged in: e->',e);
  });

  /*
      Close login modals
   */
  window.closeLoginModal();

  /*
      Add 'logged-in' class to body to signal to wordpress that we are logged in
   */
  document.body.classList.add("logged-in");

  /*
      If there is no small_profile_image set then user default profile image we submitted through the php enguque function
   */
  if (small_profile_image === null) small_profile_image = default_small_profile_image;

  /*
      Add necessary data our functions will use such as user_id, profile_image_url, etc to the body dom element
      so we can read it
   */
  document.body.setAttribute('user_id', user_id);
  document.body.setAttribute('user_name', user_name);
  document.body.setAttribute('display_name', display_name);
  document.body.setAttribute('small_profile_image', small_profile_image);

  /*
      Runs ajax query to get HTML for the top navigation bar so it can replace
      the non-logged in top navigation bar --
        NOTE: top navigation bad includes loading LOGGED_IN_NONCE
        After top header with nonce has been loaded, only THEN trigger
      the 'logged_in_without_reload_event'
   */
  function getTopNavigationHTMLLoggedIn() {
    //console.log('in JS func: getTopNavigationHTMLLoggedIn')

    var params = new FormData();
    params.append('action', 'get_top_navigation_logged_in_html');
    // params.append('load_top_nav_nonce',load_top_nav_nonce); -- I belive we are not even using this nonce

    //do ajax query to log in
    fetch(ajaxurl, {
      method: 'POST',
      body: params
    }).then(function (res) {
      return res.json();
    })["catch"](function (error) {
      // this.resetMessages();
    }).then(function (response) {
      // _self.resetMessages();

      /*
          If there was an error retrieving navigation html show error
       */
      if (response === 0 || !response.status) {
        console.log('Error - couldnt retrieve top nativation - response:', response);
        return;
      }

      /*
          If succesfull replace current navigation for logged in navigation
       */
      // const newTopNavigation = document.createElement('span');
      // newTopNavigation.innerHTML = response.top_navigation_html;
      //response.top_navigation_html
      //document.getElementById('top-navigation').replaceWith()
      // console.log('new navigation html:',response.top_navigation_html);
      jQuery('#top-navigation').replaceWith(response.top_navigation_html);
    }).then(function (response) {
      /*
          Trigger an event 'logged_in_without_reload_event' so other js can see when we've logged into site without reload
          and contains all necessary data to log user in in 'detail'
      */

      var logged_in_without_reload_event = new CustomEvent('logged_in_without_reload_event', {
        bubbles: true,
        detail: {
          user_id: user_id,
          user_name: user_name,
          small_profile_image: small_profile_image
        }
      });
      document.dispatchEvent(logged_in_without_reload_event);
    });
  }

  /*
      Replace the login button for the login modal menu
        Run an ajax query to create the html for the header and replace the non-logged in header
   */
  getTopNavigationHTMLLoggedIn();
};

/*
    This contains everything needed for the user's first login
 */

window.FirstLogin = /*#__PURE__*/function () {
  function _class3(registration_source, nonce, profile_image_nonce, username, ajaxurl) {
    _classCallCheck(this, _class3);
    //the source user registered from, can be either "none" (which is thorugh email), "fb" or "google"
    this.registration_source = registration_source;
    this.nonce = nonce;
    this.mts_dashboard_update_profile_image_nonce = profile_image_nonce;
    this.username = username;
    this.ajaxurl = ajaxurl;

    //!!!!--- remove below, just for testing
    // this.registration_source = "fb";

    /*
        If the user registered through email then they already have a username so go directly to the "upload image"
        modal to allow them to upload a profile picture
          Otherwise if user registered through a third party such as google or facebook, then first show them the
        modal to choose a username
     */
    if (this.registration_source === "none") {
      this.launchImageUploadModal();
    } else {
      this.launchUpdateUsernameModal();
    }

    // set event listeners
    this.setEventListeners();
  }

  /*
      Set event listeners on buttons
   */
  return _createClass(_class3, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;

      /*
          Set event listener for submit new username submit button
       */
      jQuery('#mts-first-login-change-username-form').submit(function (e) {
        // console.log('submitted username')

        e.preventDefault();
        _self.new_username = jQuery('#mts_first_login_new_username_input').val();
        // console.log('selected username:',_self.new_username);

        /*
            Run ajax query to update display name
         */
        e.preventDefault();
        _self.settingsFirstLoginUsernameForm = document.getElementById('mts-first-login-change-username-form');
        _self.status = document.querySelector('[data-message="mts-first-login-change-username-status"]');
        _self.successMessage = document.getElementById('mts-settings-change-displayname-success-message');

        //clears status message
        _self.resetMessages();

        //set loading message
        _self.setLoadingMessage();
        var params = new URLSearchParams(new FormData(_self.settingsFirstLoginUsernameForm)); //create url parameter object to send to ajax request

        // console.log('about to show all params below:')
        // Display the values
        // for(var value of params.values()) {
        //     console.log('value:',value);
        // }

        //do ajax query to password reset
        fetch(ajaxurl, {
          method: 'POST',
          body: params
        }).then(function (res) {
          return res.json();
        })["catch"](function (error) {
          console.log('error with submission - ', error);
          _self.resetMessages();
        }).then(function (response) {
          _self.resetMessages();
          // this.update_username_button.disabled = false;
          //console.log('response:', response);

          if (response === 0 || !response.status) {
            _self.setStatus(response.message, 'error');
            return;
          }
          _self.setStatus(response.message, 'success');
          // _self.settingsFirstLoginUsernameForm.classList.add('d-none');
          // _self.successMessage.classList.remove('d-none');

          // console.log('response:',response);

          /*
              Update the image upload nonce if the username was changed and then logged out and in, because
              it will have become invalid
           */
          // console.log(`updating old nonce: ${_self.mts_dashboard_update_profile_image_nonce} to new nonce ${_self.ajax_get_updated_upload_image_nonce()}`);
          _self.new_username = response.new_username;

          /*
              Before we launch the image upload modal we need to update all the nonces
              because we have changed the username and then load the edit profile image modal once thats done
           */
          _self.ajax_get_updated_nonces_navigation_and_upload_image_modal();
        });
      });

      /*
          Set event listener to launch newsletter modal if user: skips changing name, it shows the upload image option
       */
      $('#skipChangingUsername').each(function () {
        $(this).click(function (e) {
          _self.ajax_get_updated_nonces_navigation_and_upload_image_modal();
        });
      });

      /*
          Set event listener to launch newsletter modal if user: skips changing name, closes succesful upload image button or skips uploading image
       */
      $('#mts_first_login_image_select_skip_button').each(function () {
        $(this).click(function (e) {
          var mts_newsletter_obj = new window.MtsNewsletter();
          var newsletter_modal_data = mts_newsletter_obj.displayNewsletterSignupModal();
        });
      });
    }

    /*
        Run ajax call to get get updated user data including nonces and once thats done
        reload the top navigation bar since we have re-logged the user in after changing username
          Then load the image upload modal
     */
  }, {
    key: "ajax_get_updated_nonces_navigation_and_upload_image_modal",
    value: function ajax_get_updated_nonces_navigation_and_upload_image_modal() {
      var _self = this;
      var params = new FormData();
      params.append('action', 'mts_first_login_get_updated_nonces_and_user_data_after_login');
      // const params = {
      //     'action' : 'mts_dashboard_update_profile_image_nonce',
      // };

      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        console.log('error with submission - ', error);
        _self.resetMessages();
      }).then(function (response) {
        _self.resetMessages();
        // this.update_username_button.disabled = false;
        //console.log('response:', response);

        if (response === 0 || !response.status) {
          _self.setStatus(response.message, 'error');
          console.log('error response:', response);
          return;
        }

        /*
            Once we've updated the nonce THEN we can launch the image upload modal
         */
        _self.mts_dashboard_update_profile_image_nonce = response.nonce;

        /*
            Reload the top navigation with all necessary nonces/username/etc
         */
        console.log('xxx reponse:', response);
        console.log('About to set the following as display name:', response.display_name);
        //fakes all functionality to make it looks as though user is logged in without having to reload the page
        window.login_without_reload(response.user_id, response.user_name, null, response.display_name);

        /*
            First close the previous modal and THEN open the new image modal
         */
        jQuery("#firstModal").modal('hide'); //close the previous modal and then open the new modal;
        _self.launchImageUploadModal();
      });
    }
    /*
        Create the first modal which contains a welcome and option to change username if user did not register through email
     */
  }, {
    key: "launchUpdateUsernameModal",
    value: function launchUpdateUsernameModal() {
      var _self = this;
      var title = 'Welcome to Metaspoon!';
      var content = '';
      content += "                \n                <div class=\"alert alert-success mts-first-login-modal\" role=\"alert\">\n                    <p class=\"alert-success mb-0\" style=\"text-align: center\">\n                        <i class=\"far fa-grin-beam\"></i> <strong>Congratulations</strong>, you are now registered on Metaspoon!\n                    </p>\n                </div>\n        ";

      /*
          If user registered through email remind them to verify email
       */
      if (this.registration_source === "none") {
        content += "Don't forget to <strong>verify your email address</strong>! An email with instructions should be in your inbox right away, or it might take a few minutes.<br><br>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button>\n                </div>  \n                ";
      }

      /*
          If user registered through third party offer to change their username
       */else {
        content += "\n                Now, lets pick a new username, we've created a temporary username for you (<strong>".concat(this.username, "</strong>),\n                but you can choose your own:\n                    <br><br>\n                <form id=\"mts-first-login-change-username-form\" data-url=\"").concat(this.ajaxurl, "\">\n                        <div class=\"form-group\">\n                        <label for=\"mts_first_login_new_username_input\"><i class=\"far fa-edit\"></i> Pick a Username</label>\n                    <input type=\"text\" class=\"form-control\" id=\"mts_first_login_new_username_input\" name=\"mts_first_login_new_username_input\">\n                        <small id=\"mts_first_login_new_username_input_help\" class=\"form-text text-muted\">Or you can change it in the \"Settings\" section later.</small>\n                    </div>\n                    <input type=\"hidden\" name=\"action\" value=\"mts_first_login_update_username\">\n                    <input type=\"hidden\" name=\"nonce\" value=\"").concat(this.nonce, "\">\n        \n        \n                \n                    <p class=\"text-center mt-n1 mb-3 d-none\" data-message=\"mts-first-login-change-username-status\"></p>   \n                    \n                    <div class=\"modal-footer\">\n                        <button type=\"submit\" class=\"btn btn-primary\" id=\"mts_first_login_new_username_submit\">Pick Name</button>\n                        <button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" id=\"skipChangingUsername\">SKIP</button>\n                    </div>  \n            </form>\n           ");
      }
      var modal_id = 'firstModal';
      this.launchModal(modal_id, content, title);

      /*
          Add event to reload the page once the user closes the second modal so that the link to the profile works
       */
      jQuery("#".concat(modal_id)).on('hidden.bs.modal', function (e) {
        /*
            Replace username in menu and profile link so we dont get a broken link when user tries to go there
         */
        //replace url to user profile in top navigation section
        var oldUrl = $('#top_nav_profile_url').attr("href"); // Get current url
        var newUrl = oldUrl.replace(_self.username, _self.new_username);
        jQuery('#top_nav_profile_url').attr("href", newUrl);

        //replace username in top navigation menu
        jQuery('#top_nav_profile_username').html(_self.new_username);
      });
    }

    /*
        This modal shows user that updating username was succesful and in future will allow user to update their profile picture
     */
  }, {
    key: "launchImageUploadModal",
    value: function launchImageUploadModal() {
      var _self = this;

      // console.log('second modal launched');
      var title = 'Welcome to Metaspoon!';
      var content = '';

      //if the user registers directly on the site or if user skips changing the username
      if (this.registration_source === "none" || !_self.new_username) {
        content += "                \n                <div class=\"alert alert-success mts-first-login-modal\" id=\"mts-first-login-top-success-message\" role=\"alert\">\n                    <p class=\"alert-success mb-0\" style=\"text-align: center\">\n                        <i class=\"far fa-grin-beam\"></i> <strong>Congratulations</strong>, you are now registered on Metaspoon!\n                    </p>\n                </div>\n        ";
      } else {
        content += "\n                <div class=\"alert alert-success mts-first-login-modal\" id=\"mts-first-login-top-success-message\" role=\"alert\">\n                    <p class=\"alert-success mb-0\" style=\"text-align: center\">\n                        <i class=\"far fa-grin-beam\"></i> Good job <strong>".concat(_self.new_username, "</strong>, your username has been updated!\n                    </p>\n                </div>      \n                ");
      }
      content += "\n                <div id=\"mts-first-login-upload-image-text\" style=\"margin-bottom:15px;text-align: center\">Now let's <strong>upload a profile image</strong> for you. If you want to skip this step you can press SKIP below and upload\n                a profile image later by going to your \"Profile\". You can do so by clicking on it on the top right menu.</div>\n                <div style=\"text-align: center;margin-bottom:15px;\">\n                    <img id=\"mts_first_login_profile_image_preview\" class=\"dashboard-profile-image rounded-circle\" style=\"display:none;\"></img>\n                </div>\n                <div class=\"row justify-content-center mb-4\">\n                      <a href='#' id='mts-first-login-edit-profile-image'>\n                        <span class=\"btn btn-primary btn-sm\">\n                            <i class=\"fas fa-edit mr-1\"></i>Upload Profile Image\n                            <div id=\"mts-first-login-image-spinner\" class=\"spinner-border spinner-border-sm text-white\" style=\"display:none;\" role=\"status\">\n                                <span class=\"sr-only\">Loading...</span>\n                            </div>\n                        </span>\n                     </a>\n\n                    <form id=\"mts-first-login-udpate-image-form\" enctype=\"multipart/form-data\" data-url=\"".concat(this.ajaxurl, "\">\n                        <input id=\"mts-first-login-image-file-input\" type=\"file\" name=\"mts-first-login-profile-image-file\" id=\"mts-dashboard-profile-image-file\" style=\"display: none;\" />\n                        <input type=\"hidden\" name=\"action\" value=\"mts_first_login_update_profile_image\">\n                        <input type=\"hidden\" name=\"mts_dashboard_update_profile_image_nonce\" value=\"").concat(this.mts_dashboard_update_profile_image_nonce, "\">\n                    </form>\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" id=\"mts_first_login_image_select_skip_button\">SKIP</button>\n                </div>  \n        ");
      var modal_id = "secondModal";
      this.launchModal(modal_id, content, title);

      // jQuery('#mts_first_login_image_select_skip_button,#skipChangingUsername').click( e => {
      //
      //         console.log('Clicked skip button - now launch the newlsetter!')
      //
      //         const title = 'testig the title - newsletter';
      //         const content = 'testing the content';
      //         const modal_id = 'registerToNewsletterModal';
      //         this.launchModal(modal_id,content,title);
      //     });

      /*
           Action when user clicks on "Upload Profile Image"
        */
      jQuery('#mts-first-login-edit-profile-image').click(function (e) {
        e.preventDefault();

        //console.log('clicked on edit image');
        /*
            If we are in the process of uploading an image clicking the button wont do anything, it will be disabled
         */
        if (_self.currently_uploading_image === true) {
          console.log('Cant press button while image is uploading');
          return;
        }

        //trigger the hidden file upload input button
        jQuery('#mts-first-login-image-file-input').click();
      });

      /*
         Set event listener for when image is uploaded into system
      */

      jQuery('#mts-first-login-image-file-input').change(function (e) {
        var fd = new FormData();
        //console.log(fd_<?php echo $i; ?>);
        var file = e.target.files[0];
        // console.log('file:',file);

        /*
            If file size is above about 4.5 mb then give error and dont upload
         */
        var maxsizef = 4621440;
        if (file.size > maxsizef) {
          alert('Error: Your image is too large! Images can only be up to 4.5MBs');
          _self.finishedUploadAttempt(false);
          return;
        }

        //set the button to disabled so we cant press it again while we are uploading an image
        _self.currently_uploading_image = true;

        // jQuery('#mts_first_login_update_profile_image').show(); //add loading spinner while image is uploading
        jQuery('#mts-first-login-image-spinner').show();
        fd.append('file', file);
        fd.append('action', 'mts_dashboard_update_profile_image');
        fd.append('mts_dashboard_update_profile_image_nonce', _self.mts_dashboard_update_profile_image_nonce);
        //console.log('params FD:', fd.toString())

        // Display the values
        // for(var value of fd.values()) {
        //     console.log('value:',value);
        // }

        //do ajax query
        fetch(_self.ajaxurl, {
          method: 'POST',
          body: fd
        }).then(function (res) {
          return res.json();
        })["catch"](function (error) {
          console.log(error);
        }).then(function (response) {
          //if ajax call returns error message (false)
          if (response === 0 || !response.status) {
            alert(response.message);
            console.log('error with response:', response.message);
            _self.finishedUploadAttempt(false);
            return;
          }

          //if ajax call returns true value
          // console.log('response:',response);
          // console.log('success with ajax:',response.message,' image id:'+response.profile_image_url);
          _self.reloadProfileImage(response.profile_image_url);
          _self.finishedUploadAttempt(true);
        });
      });
    }

    /*
        This function runs whenever we finished an attempt at trying to upload an image wether succesful or not
          was_success: (bool), true if image was uploaded succesfully and false if it was not
     */
  }, {
    key: "finishedUploadAttempt",
    value: function finishedUploadAttempt(was_success) {
      /*
          After image is uploaded, hide the spinner and re-enable the upload button
       */
      var _self = this;
      jQuery('#mts-first-login-image-spinner').hide();
      _self.currently_uploading_image = false; //set currently upload to false as we are now done
      jQuery('#mts-first-login-image-file-input').val(null); //clean up file we tried to upload from input form so if we try to re-upload the same file it will work, otherwise onchange wont trigger

      /*
          If uploading image was succesfully loaded then change the text and hide success message
          Replaces SKIP button for Close button
       */
      if (was_success) {
        var success_message = "Great, <strong>you're all done</strong>! If you want to change you image you can try again.";

        //if user registered through email we should remind them to verify their email address
        if (_self.registration_source === "none") success_message += "<br>And don't forget to <strong>verify your email address</strong>!";
        console.log('registration source:', _self.registration_source, 'success message:', success_message);

        //change text in modal
        jQuery('#mts-first-login-upload-image-text').html(success_message);
        jQuery('#mts-first-login-top-success-message').hide(); //hide success message
        jQuery('#mts_first_login_image_select_skip_button').replaceWith("<button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" id=\"closeImageUploadSuccessModal\">Close</button>"); //replace skip button for continue button

        //add event for when modal is closed
        jQuery('#closeImageUploadSuccessModal').each(function () {
          $(this).click(function (e) {
            var mts_newsletter_obj = new window.MtsNewsletter();
            var newsletter_modal_data = mts_newsletter_obj.displayNewsletterSignupModal();
          });
        });
      }
    }

    /*
        Reload the profile image with new image from API
          profile_image_url: (string), updated url of the version of the profile image
       */
  }, {
    key: "reloadProfileImage",
    value: function reloadProfileImage() {
      var profile_image_url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      //console.log(this.dashboard_profile_image_url);
      jQuery('#mts_first_login_profile_image_preview').attr('src', profile_image_url);
      jQuery('#mts_first_login_profile_image_preview').show();

      //show profile image in the top navigation bar
      jQuery('#top-navigation-profile-image').attr('src', profile_image_url);

      //set image in body tag for comments to use if we just changed image and are commenting
      document.body.setAttribute('small_profile_image', profile_image_url);
    }

    /*
        Sets a message in status
          message: (string), the message we want to set in status
        type: (string), the type of message, sets the font size/color/etc
     */
  }, {
    key: "setStatus",
    value: function setStatus(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      this.resetMessages();
      this.status.classList.remove('d-none'); //make status div invisible again
      this.status.classList.add(type);
      this.status.innerHTML = message;
    }

    /*
        Resets status message in modal
     */
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      if (this.status) {
        this.status.innerHTML = '';
        this.status.classList.remove('success', 'error', 'loading');
        this.status.classList.add('d-none'); //make status div invisible again
      }
    }

    /*
        Shows loading message in status
     */
  }, {
    key: "setLoadingMessage",
    value: function setLoadingMessage() {
      // console.log('in set loading message');
      this.setStatus('<div class="spinner-border text-primary spinner-border-sm mr-1"></div>Loading...', 'loading');
    }

    /*
        General function for lanuching a bootstrap modal
          modal: (string), the html for the modal to show
        modal_id: (string), the id of the modal
     */
  }, {
    key: "launchModal",
    value: function launchModal(modal_id, content, title) {
      var modal = "\n            <div class=\"modal fade\" id=\"".concat(modal_id, "\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"").concat(modal_id, "\" aria-hidden=\"true\">\n                <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n                    <div class=\"modal-content\">\n                        <div class=\"modal-header\">\n                            <div class=\"row\">\n                                <div style=\"height:40px;\"><img src=\"/wp-content/uploads/site-images/metaspoon_logo_square.png\" class=\"mr-2 ml-3\" style=\"width:40px;height:40px;\"></div>\n                                <h5 class=\"modal-title align-self-center\" id=\"exampleModalLongTitle\">\n                                     ").concat(title, "\n                                </h5>\n                            </div>\n                            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <span aria-hidden=\"true\">&times;</span>\n                            </button>\n                        </div>\n                        <div class=\"modal-body\">\n                            ").concat(content, "\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");

      /*
          If modal html hasnt been added to the page yet then add it
       */
      if (!$("#".concat(modal_id)).length) {
        //add modal text to the html
        $('body').prepend(modal);
      }

      //open the modal
      $("#".concat(modal_id)).modal('show');

      /*
          Add event to delete modal when closed/hidden that way when a modal is opened again it will be fresh and not have old datya
       */
      $("#".concat(modal_id)).on('hidden.bs.modal', function (e) {
        $("#".concat(modal_id)).remove();
      });
    }
  }]);
}();

},{}]},{},[1]);
